import { Severity } from '@msi/cobalt-prime';
import { DeviceType } from '@premise-hazard-models/device-type.model';
import { PremiseHazardPriorityType } from '@premise-hazard-models/premise-hazard-priority-type.model';
import { Units } from '@models/units.model';

/**
 * Global constants for use in Angular templates.
 * These provide strongly typed access to enum values and other constants
 * that need to be referenced in component HTML templates.
 */
export class TemplateConstants {
  // Callout Types
  public static readonly InfoCalloutType: Severity = Severity.Info;
  public static readonly ErrorCalloutType: Severity = Severity.Error;
  public static readonly WarningCalloutType: Severity = Severity.Warning;

  // Units
  public static readonly Units: string[] = Object.values(Units).map(val => val.toString());

  // Number Formats
  public static readonly NumberFormats: string[] = ['1.0', '1.0', '1.0-5', '1.0-6'];

  // roles
  public static readonly QueryPermissionName: string = 'Query';
  public static readonly CommandPermissionName: string = 'Command';
  public static readonly UploadPermissionName: string = 'Upload';
  public static readonly AdminPermissionName: string = 'Admin';

  // Premise Hazard Types
  public static readonly PurgeTypes: string[] = ['Do not purge', 'Automatically', 'Purge Manually'];
  public static readonly PriorityTypes: PremiseHazardPriorityType[] = Object.values(PremiseHazardPriorityType)
    .filter(val => Number.isNaN(Number(val))) as PremiseHazardPriorityType[];
  public static readonly DeviceTypes: DeviceType[] = Object.values(DeviceType)
    .filter(val => Number.isNaN(Number(val))) as DeviceType[];

  // Common IDs
  public static readonly EmptyId: string = '00000000-0000-0000-0000-000000000000';
  
  // Theme
  public static readonly ThemeTexts: string[] = ['Light Mode', 'Dark Mode'];
  
  // Items per page
  public static readonly ItemsPerPageValue: number = 100;
}

